export const calculateOffsetTopFromScrollContainer = (
	element: HTMLElement | null,
	scrollContainer: HTMLElement,
): number => {
	let offset = 0;
	let currentElement = element;

	/**
	 * If we've reached the scroll container or the element is null (scrollContainer not found after traversal)
	 * we return the accumulated offset.
	 * This is to avoid calling getBoundingClientRect which can be more expensive.
	 */
	while (currentElement && currentElement !== scrollContainer) {
		offset += currentElement.offsetTop;
		currentElement = currentElement.offsetParent as HTMLElement | null;
	}

	return offset;
};
